import React from 'react';
import CategoryTags from '../../components/CategoryTags';
import Favorite from '../../components/Favorite';
import SelectState from '../../components/SelectState';

function ScheduleItemMin({ scheduleChanger, config, schedule }) {
  const [canSelect, ] = React.useState(config.can_select);
  const [showDate, ] = React.useState(schedule.new_date_group);
  const [registrationMode, ] = React.useState(config.registration_mode);
  const [isSelectLock, ] = React.useState(!config.can_deselect);
  const dateFormatter = (opts) => new Intl.DateTimeFormat('en', opts);
  const startDate = new Date(schedule.start_date.replace(/-/g, '\/'));

  return (
    <div className="timeline margin-10" data-schedule-id={schedule.id}>
      {
        showDate ? (
          <div className="date-header margin-30">
            <h5>
              {dateFormatter({ day: "2-digit", month: "long", year: "numeric" }).format(startDate)}
            </h5>
          </div>
        ) : ""
      }
      <div className="time-block">
        <div className="session-card">
          {
            canSelect || !isSelectLock ? (
              registrationMode ? (
                <SelectState scheduleChanger={scheduleChanger} config={config} scheduleItem={schedule} />
              ) : (
                <Favorite scheduleChanger={scheduleChanger} config={config} scheduleItem={schedule} />
              )
            ) : ("")
          }
          <a
            className="session-title collapsed"
            data-toggle="collapse"
            href={`#session_${schedule.id}_${schedule.attendee_id}-${schedule.line_item_id}`}
            aria-expanded="false"
            aria-controls="footwear"
          >
            <i className="fa-solid fa-angle-down"></i> {schedule.title}
          </a>
          <div className="session-time">
            {[
              schedule.time_start,
              ...(schedule.time_end ? [schedule.time_end] : []),
            ].join(' - ')} {config.time_zone}
          </div>
          <div className="collapse" id={`session_${schedule.id}_${schedule.attendee_id}-${schedule.line_item_id}`}>
            <CategoryTags tags={schedule.category_tags} />
            <div className="session-desc">
              <p>{schedule.description}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ScheduleItemMin;
